import axios from "axios";
import firebaseApp from "../init-firebase";
import {
  getAuth,
  GoogleAuthProvider,
  TwitterAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  signInWithRedirect,
  getRedirectResult,
  fetchSignInMethodsForEmail,
} from "firebase/auth";
import { post } from "../utils/request";
import API from "../conf/API";
import DataCenter from "../modules/DataCenter";

const auth = getAuth(firebaseApp);

// const CHANNEL_FIREBASE = "Firebase";
// const SERVICE_ID = "officialweb";

// const Address_Localhost = {
//   AccountServer: "http://localhost:18881/",
// };

// const Address_Production = {
//   AccountServer: "https://acc.metavirus.games/",
// };

// const Address_PublicTest = {
//   AccountServer: "https://acc-test.metavirus.games/",
// };

// const AddressOverride = Address_Production;

// const Address_Server =
//   AddressOverride != null
//     ? AddressOverride
//     : process.env.NODE_ENV == "production"
//       ? Address_Production
//       : Address_PublicTest;

// const API = {
//   account: Address_Server.AccountServer + "account/",
//   captcha: Address_Server.AccountServer + "captcha/request",
//   quest: Address_Server.AccountServer + "quest/",

//   registerRequest: () => API.account + "registerRequest",
//   verifyCode: () => API.account + "verifyCode",
//   resendCode: () => API.account + "resendCode",
//   loginRequest: () => API.account + "loginRequest",
//   loginRequestV2: () => API.account + "loginRequestV2",
//   loginCheck: () => API.account + "loginCheck",
//   sendCodeRequest: () => API.account + "requestSendCode",
//   verifyCodeByToken: () => API.account + "verifyCodeByToken",
//   updateReferrer: () => API.account + "updateReferrer",
//   getProfile: () => API.account + "getProfile",
//   bindSocialMediaAccount: () => API.account + "bindSocialMediaAccount",

//   requestCaptcha: () => API.captcha,

//   //social media api
//   requestSocialOAuthToken: () => API.account + "requestSocialOauthToken",
//   connectSocialMediaToUser: () => API.account + "connectSocialMediaToUser",

//   //quest api
//   questGetInfo: () => API.quest + "info",
//   questGetUserProgress: () => API.quest + "user_progress",
//   questVerifyEntry: () => API.quest + "user_verify_entry",
//   questClaimReward: () => API.quest + "user_claim_reward",
//   questGetUserData: () => API.quest + "user_data",
// };

// const AccountServer = {


//   /**
//    *
//    * @param {userToken} token
//    * @param {deviceId} device
//    * @returns
//    */
//   loginRequest: async (token) => {
//     return await axios.post(API.loginRequestV2(), {
//       username: token,
//       password: "",
//       channel: CHANNEL_FIREBASE,
//       serviceId: SERVICE_ID,
//     });
//   },

//   /**
//    * 请求发送验证码邮件
//    * @param {string} token
//    * @returns
//    */
//   sendVerifyCodeRequest: async (token) => {
//     return await axios.postForm(API.sendCodeRequest(), {
//       firebaseToken: token,
//     });
//   },

//   /**
//    *
//    * @param {string} firebaseToken
//    * @param {string} verifyCodeToken
//    * @param {string} code
//    * @returns
//    */
//   verifyCode: async (firebaseToken, verifyCodeToken, code) => {
//     return await axios.post(API.verifyCodeByToken(), {
//       username: firebaseToken,
//       token: verifyCodeToken,
//       code: code,
//     });
//   },

//   updateReferrer: async (
//     firebaseToken,
//     referralCode,
//     captchaKey,
//     captchaCode
//   ) => {
//     return await axios.postForm(API.updateReferrer(), {
//       firebaseToken: firebaseToken,
//       referralCode: referralCode,
//       captchaKey,
//       captchaCode,
//     });
//   },

//   getProfile: async (accountId, firebaseToken) => {
//     return await axios.get(API.getProfile(), {
//       params: {
//         id: accountId,
//         token: firebaseToken,
//         serviceId: SERVICE_ID,
//         channel: CHANNEL_FIREBASE,
//       },
//       headers: {
//         accountId: accountId,
//         loginKey: firebaseToken,
//         serviceId: SERVICE_ID,
//         channel: CHANNEL_FIREBASE,
//       },
//     });
//   },
// };

// export { AccountServer };

const loginRequest = async (firebaseToken) => {
  const channel = "Firebase";
  const ret = await post(API.account_login(), { username: firebaseToken, password: "", serviceId: DataCenter.serviceId(), channel: channel });
  if (ret.code == 0) {
    const { accountId } = ret.retObject;
    //DataCenter.setLoginInfo(cookieToken.id, cookieToken.key)
    //DataCenter.init();
    return { errorCode: 0, id: accountId, key: firebaseToken };
  } else {
    return { errorCode: ret.code, msg: ret.msg }
  }
}

const Firebase = {
  signOut: async () => {
    await signOut(auth);
    console.log("signed out");
  },

  currentUser: () => {
    return auth.currentUser;
  },

  /**
   * 邮箱注册并登录
   *
   * 返回账号服务器的登录结果及firebaseToken
   *
   * @param {string} email
   * @param {string} password
   * @returns {Promise<{result:object, firebaseToken:string, user:User}>}
   */
  signInWithCreateEmailAndPassword: async (email, password) => {
    const credential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    const token = await credential.user.getIdToken();
    //await post(API.account_login(), { username: DataCenter.firebaseToken, password: "", serviceId: DataCenter.serviceId(), channel: DataCenter.channel })
    // .then(ret => {
    // 	if (ret.code == 0) {
    // 		const { accountId } = ret.retObject;
    // 		//DataCenter.setLoginInfo(cookieToken.id, cookieToken.key)
    // 		//DataCenter.init();
    // 		JSEvent.emit(Events.Login.LoginSuccessful, { id: accountId, key: DataCenter.firebaseToken });
    // 		nav("/")
    // 	} else {
    // 		cookie.remove(loginCookie)
    // 	}
    // 	setLoading(false);
    // })

    // if (result.status != 200 || result.data.error) {
    //   const e = new Error(result);
    //   e.result = result;
    //   throw e;
    // }

    // return {
    //   result: result.data,
    //   firebaseToken: token,
    //   user: credential.user,
    // };
  },

  /**
   * 邮箱密码登录
   *
   * 返回账号服务器的登录结果及firebaseToken
   *
   * @param {string} email
   * @param {string} password
   * @returns {Promise<{result:object, firebaseToken:string, user:User}>}
   */
  signInWithEmailAndPassword: async (email, password) => {
    const fetchResult = await fetchSignInMethodsForEmail(auth, email);
    console.log("=======", fetchResult);
    if (fetchResult != null && (fetchResult.length > 1 || (fetchResult[0] != null && fetchResult[0] != "password"))) {
      return {
        singinProviders: fetchResult,
      }
    }

    console.log("login with email ", email)

    const credential = await signInWithEmailAndPassword(auth, email, password);
    const token = await credential.user.getIdToken();
    console.log("login with email got token ", token)
    const result = await loginRequest(token);

    if (result.errorCode != 0) {
      throw result;
    }

    return {
      result: result.id,
      firebaseToken: token,
      user: credential.user,
    };
  },

  /**
   * Google登录
   * @returns {Promise<{result:object, firebaseToken:string, oauthToken:string, user:User}>}
   */
  signInWithGoogle: async () => {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: "select_account",
    });
    provider.addScope("profile");
    provider.addScope("email");
    const popResult = await signInWithPopup(auth, provider);
    const oauth = GoogleAuthProvider.credentialFromResult(popResult);
    const firebaseToken = await popResult.user.getIdToken();

    const result = await loginRequest(firebaseToken);

    if (result.errorCode != 0) {
      throw result;
    }

    return {
      id: result.id,
      firebaseToken,
      oauthToken: oauth.accessToken,
      user: popResult.user,
    };
  },

  /**
   * Twitter登录
   * @returns {Promise<{result:object, firebaseToken:string, oauthToken:string, user:User}>}
   */
  signInWithTwitter: async () => {
    const provider = new TwitterAuthProvider();
    provider.addScope("profile");
    provider.addScope("email");
    provider.setCustomParameters({
      prompt: "select_account",
    });
    const popResult = await signInWithPopup(auth, provider);

    const oauth = TwitterAuthProvider.credentialFromResult(popResult);

    const firebaseToken = await popResult.user.getIdToken();

    const result = await loginRequest(firebaseToken);
    if (result.errorCode != 0) {
      throw result;
    }

    return {
      id: result.id,
      firebaseToken,
      oauthToken: oauth.accessToken,
      user: popResult.user,
    };
  },
};

export { Firebase };
